var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13",
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.145,
    height: 97.049,
    viewBox: "0 0 97.145 97.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 97.145,
    height: 97.049,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M83.021,50.5a25.25,25.25,0,1,1,25.25-25.25A25.279,25.279,0,0,1,83.021,50.5m0-47.587a22.337,22.337,0,1,0,22.338,22.337A22.363,22.363,0,0,0,83.021,2.914",
    transform: "translate(-28.686 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M100,31.073c-.848-.134-5.078-.922-5.049-3.281.035-2.94,2.835-3.658,3.692-3.809,2.5-.436,5.553.555,6.58,3.293a1.457,1.457,0,0,0,2.728-1.023,8.218,8.218,0,0,0-6.6-5.145V17.145a1.457,1.457,0,1,0-2.913,0v3.929c-.1.014-.2.023-.3.04-3.667.642-6.062,3.25-6.1,6.643C92,30.886,94.807,33.2,99.546,33.95c3.667.579,5.8,2.335,5.568,4.581-.2,1.915-2.224,3.811-5.269,3.656-5.3-.261-6.226-3.886-6.233-3.922a1.457,1.457,0,1,0-2.862.546c.292,1.527,2.24,5.382,7.688,6.161v3.962a1.457,1.457,0,0,0,2.913,0V45.017c3.223-.448,6.293-2.635,6.66-6.186.3-2.948-1.611-6.748-8.012-7.758",
    transform: "translate(-45.048 -7.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M25.26,123.088c6.281-7.457,11.464-10.424,17.9-10.424,5.923,0,8.94.63,14.082,4.167a1.455,1.455,0,0,0,.826.256H69.508c5.153,0,6.181,4.955,6.384,7.081H53.335a1.457,1.457,0,0,0,0,2.913h22.99a2.528,2.528,0,0,0,1.831-.793,2.492,2.492,0,0,0,.679-1.845c-.226-3.941-1.591-6.833-4.057-8.6a9.305,9.305,0,0,0-5.269-1.672H58.52c-5.607-3.777-9.314-4.423-15.356-4.423-7.236,0-13.174,3.3-19.942,11.242Z",
    transform: "translate(-11.531 -54.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M122.967,99.81c-5.221-4.812-10.794-5-16.564-.56-3.863,2.971-9.241,7.181-12.675,9.876a12.252,12.252,0,0,1,1.506,2.52c3.409-2.676,8.981-7.038,12.944-10.088,4.562-3.509,8.439-3.474,12.523.13L91.6,129.776a.556.556,0,0,1-.389.157H53.637l2.834,2.913H91.208a3.453,3.453,0,0,0,2.413-.975l29.369-28.341a2.591,2.591,0,0,0,.788-1.888,2.536,2.536,0,0,0-.811-1.832",
    transform: "translate(-26.633 -47.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M21.789,162.923a1.457,1.457,0,0,1-1.048-2.468l5.239-5.429-18.3-18.81L2.5,141.578a1.457,1.457,0,1,1-2.1-2.023l6.22-6.444a1.459,1.459,0,0,1,1.045-.445h0a1.455,1.455,0,0,1,1.044.441l20.332,20.9a1.457,1.457,0,0,1,0,2.027l-6.22,6.444a1.453,1.453,0,0,1-1.048.445",
    transform: "translate(0 -65.874)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.68a13144d9770bcb6b643440f4895615.svg";
export { ForwardRef as ReactComponent };